import { get, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROItem = get('reservation.ROItem');

export const getAll = createSelector(getROItem, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrderedPending = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(getROItem, get('order'));

export const getIsFetching = createSelector(getROItem, get('fetching'));
export const getIsFetched = createSelector(getROItem, get('fetched'));

export const getFetchingError = createSelector(getROItem, get('fetchingError'));

export const getIsSaving = createSelector(getROItem, get('saving'));

export const getIsSaved = createSelector(getROItem, get('saved'));

export const getIsDeleting = createSelector(getROItem, get('deleting'));

export const getIsDeleted = createSelector(getROItem, get('deleted'));

export const getDeletingError = createSelector(getROItem, get('deletingError'));
